import { authApi } from "utils";
import { NAV, BANNER } from "constants/types";


export const getStatus = () => () =>
    authApi.get(`/status`)
        .then(res => {
            if (res.status === 200) {
                return res
            } else {
                throw res
            }
        })
        .catch(err => {
            throw err
        });


export const toggleNav = (isMinimized) => (dispatch) => {
    if(isMinimized) {
        dispatch({
            type: NAV.SUB_CATEGORY,
            payload: null
        })
    }

    dispatch({
        type: NAV.OPEN_NAV,
        payload: isMinimized
    })
}

export const setBannerHeight = (height) => (dispatch) => {
    dispatch({
        type: BANNER.HEIGHT,
        payload: height
    })
}

export const setSubcategory = (name) => (dispatch) => {
    dispatch({
        type: NAV.SUB_CATEGORY,
        payload: name
    })
}

export const openMobile = (payload) => (dispatch) => {
    dispatch({
        type: NAV.OPEN_MOBILE,
        payload: payload
    })
}